import {
  ColorsNeutral500,
  Dimensions1,
  Dimensions4,
  Dimensions8,
} from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const wrapper = css({
  '&.MuiCard-root': {
    marginBottom: Dimensions8,
    marginTop: Dimensions8,

    '& .MuiCardContent-root': {
      padding: Dimensions4,
    },

    '& .MuiTypography-caption': {
      color: ColorsNeutral500,
    },
  },
});

const detailsContainer = css({
  '&.MuiStack-root': {
    padding: Dimensions4,
    justifyContent: 'space-around',
    gap: Dimensions1,
  },
});

const details = css({
  '&.MuiStack-root': {
    justifyContent: 'space-around',
    flexDirection: 'row',
    flexWrap: 'wrap',

    '@media (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
});

const detailsItem = css({
  '&.MuiStack-root': {
    flexDirection: 'column',
    flex: 1,
  },
});

const buttons = css({
  '&.MuiStack-root': {
    height: '100%',
    justifyContent: 'space-around',
  },
});

const ActionCardStyles = {
  wrapper,
  detailsContainer,
  details,
  detailsItem,
  buttons,
};

export default ActionCardStyles;
